import { render } from "./CommunitySettings.vue?vue&type=template&id=130acee9&scoped=true"
import script from "./CommunitySettings.vue?vue&type=script&lang=js"
export * from "./CommunitySettings.vue?vue&type=script&lang=js"

import "./CommunitySettings.vue?vue&type=style&index=0&id=130acee9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130acee9"]])

export default __exports__